import { ComponentType } from 'react';

import PortalSettings from 'views/PortalSettings/PortalSettings/PortalSettings';

import { CompanySettings, DeveloperSettings, EventsSettings, IntegrationProfiles, IntegrationSettings, PaymentSettings, PlayerAuthSettings, StoreLayout, StoreSettings, UsersSettings } from 'components/Settings';
import { ESettingsState } from 'components/Settings/Settings.types';

import { ERouteContext, SettingsConfig } from '../types';

const basePaths = [
  ESettingsState.USERS,
  ESettingsState.INTEGRATION,
  ESettingsState.EVENTS
];

export const settingsConfigMap: Record<ERouteContext, SettingsConfig> = {
  [ERouteContext.PROJECT]: {
    defaultTab: ESettingsState.DEVELOPER_SETTINGS,
    paths: [
      ESettingsState.COMPANY,
      ESettingsState.DEVELOPER_SETTINGS,
      ESettingsState.PROFILES,
      ESettingsState.PLAYER_AUTH,
      ESettingsState.PAYMENTS,
      ESettingsState.LAYOUT,
      ESettingsState.STORE_SETTINGS,
      ...basePaths
    ]
  },
  [ERouteContext.PORTAL]: {
    defaultTab: ESettingsState.DEVELOPER_SETTINGS,
    paths: [
      ESettingsState.PORTAL,
      ESettingsState.DEVELOPER_SETTINGS,
      ESettingsState.PLAYER_AUTH,
      ...basePaths
    ]
  },
  [ERouteContext.PORTAL_LEVEL_STORE]: {
    defaultTab: ESettingsState.DEVELOPER_SETTINGS,
    paths: [
      ESettingsState.COMPANY,
      ESettingsState.DEVELOPER_SETTINGS,
      ESettingsState.PAYMENTS,
      ESettingsState.LAYOUT,
      ESettingsState.STORE_SETTINGS,
      ...basePaths
    ]
  }
};

export const componentMap: Record<string, ComponentType<any>> = {
  [ESettingsState.DEVELOPER_SETTINGS]: DeveloperSettings,
  [ESettingsState.PORTAL]: PortalSettings,
  [ESettingsState.COMPANY]: CompanySettings,
  [ESettingsState.USERS]: UsersSettings,
  [ESettingsState.INTEGRATION]: IntegrationSettings,
  [ESettingsState.PROFILES]: IntegrationProfiles,
  [ESettingsState.PLAYER_AUTH]: PlayerAuthSettings,
  [ESettingsState.PAYMENTS]: PaymentSettings,
  [ESettingsState.LAYOUT]: StoreLayout,
  [ESettingsState.STORE_SETTINGS]: StoreSettings,
  [ESettingsState.EVENTS]: EventsSettings
};